import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const FileInput = forwardRef(({ accept, onChange }, ref) => {
  return (
    <input type="file" ref={ref} style={{ display: "none" }} accept={accept} onChange={onChange} />
  );
});

FileInput.propTypes = {
  accept: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

FileInput.displayName = "FileInput";

export default FileInput;
